import {each, lowerFirst, kebabCase, isArray, isFunction} from 'lodash';
// TODO: W wolnej chwili przepisac na klase https://github.com/easysend/website/pull/12

const EVENT_REGEX = /^on/;

export const querySelector = (value) => {
    return window.document.querySelector(value);
};

export const querySelectorAll = (value) => {
    return window.document.querySelectorAll(value);
};

export const addEventListener = (elements, eventName, handler) => {
    if (!isFunction(handler)) {
        throw new Error('Handler have to be a function');
    }

    if (elements instanceof NodeList) {
        return Array.prototype.forEach.call(elements, (e) => addEventListener(e, eventName, handler));
    }

    return elements.addEventListener(eventName, handler);
};

export const removeEventListener = (elements, eventName, handler) => {
    if (!isFunction(handler)) {
        throw new Error('Handler have to be a function');
    }

    if (elements instanceof NodeList) {
        return Array.prototype.forEach.call(elements, (e) => removeEventListener(e, eventName, handler));
    }

    return elements.removeEventListener(eventName, handler, true);
};

export const getClosestElement = (target, element) => {
    if (!(target instanceof HTMLElement)) {
        throw new Error('Only single HTML elements are allowed');
    }

    do {
        if (target.querySelector(element)) {
            return target.querySelector(element);
        }
    } while (target = target.parentNode); //eslint-disable-line

    return null;
};

export const appendElement = (element, parent) => {
    if (!(element instanceof HTMLElement) || (parent && !(parent instanceof HTMLElement))) {
        throw new Error('Only single HTML elements are allowed');
    }

    parent = parent || window.document.body;

    return parent.append(element);
};

export const removeElement = (element) => {
    if (!(element instanceof HTMLElement)) {
        throw new Error('Only single HTML elements are allowed');
    }

    return element.parentNode.removeChild(element);
};

export const hasClass = (element, className) => {
    if (!(element instanceof HTMLElement)) {
        throw new Error('Only single HTML elements are allowed');
    }

    return element.classList.contains(className);
};

export const addClass = (element, className) => {
    if (element instanceof NodeList) {
        return each(element, (el) => addClass(el, className));
    }

    element.classList.add(className);
};

export const removeClass = (element, className) => {
    if (element instanceof NodeList) {
        return each(element, (el) => removeClass(el, className));
    }

    element.classList.remove(className);
};

export const toggleClass = (element, className, condition = true) => {
    if (element instanceof NodeList) {
        return each(element, (el) => addClass(el, className));
    }

    if (element.classList.contains(className) || !condition) {
        return element.classList.remove(className);
    }

    element.classList.add(className);
};

export const getData = (element, attribute) => {
    attribute = `data-${kebabCase(attribute)}`;

    return element.getAttribute(attribute);
};

export const createElement = (elementName, attributes = {}, children = []) => {
    const element = document.createElement(elementName);

    if (!attributes) {
        attributes = {};
    }

    const styles = attributes.style;
    attributes.style = undefined;

    if (styles) {
        for (const styleName of Object.keys(styles)) {
            element.style[styleName] = styles[styleName];
        }
    }

    const events = Object.keys(attributes).filter((key) => key.match(EVENT_REGEX));
    for (const eventKeyName of events) {
        const eventName = lowerFirst(eventKeyName.replace(EVENT_REGEX, ''));
        element.addEventListener(eventName, attributes[eventKeyName]);
    }

    const restAttributes = Object.keys(attributes).filter((key) => !key.match(/^on/));
    for (const attributeKeyName of restAttributes) {
        const attributeName = kebabCase(attributeKeyName);
        let attributeValue = attributes[attributeKeyName];

        if (isArray(attributeValue)) {
            attributeValue = attributeValue.join(' ');
        }

        element.setAttribute(attributeName, attributeValue);
    }

    for (const child of children) {
        element.append(child);
    }

    return element;
};
